import React, { useRef } from "react";
import { getEntityActionDescription, getEntityActionDisabledReason, getEntityActionLabel, getEntityActionUrl, isEntityActionDelete, shouldShowEntityAction } from "./utils/entityActionsCore.js";
import DotsMenu from "../DotsMenu";
import EntityActionModal from "./EntityActionModal.jsx";
import { serviceIsLoading, useServiceHook } from "rylak-common";
import { fetchEntityActions } from "../../services";
import { COLORS } from "rylak-common/src/constants";
import EntityActionButton from "~/components/entityAction/EntityActionButton.jsx";

export default function EntityActionsDotsMenu(props) {
    const {
        appProps,
        onSuccess,
        onError,
        onOpenModal,
        entity,
        entityActionsServiceData,
        entityActions = entity?.entityActions,
        extraItems,
        entityType,
        hideIfEmpty,
        entityActionManualData,
        fetchData,
        loading: propsLoading,
        initialLanguageCode,
    } = props;

    const { serviceData: entityActionsServiceDataLocal } = useServiceHook({
        appProps,
        fetchRequested: !!((!!fetchData || entityType) && !entityActionsServiceData && !entityActions),
        fetchData: fetchData || { entityType },
        fetchFn: fetchEntityActions,
    });

    const loading = propsLoading || serviceIsLoading(entityActionsServiceData) || serviceIsLoading(entityActionsServiceDataLocal);

    const actualEntityActions = entityActionsServiceData ? entityActionsServiceData?.data : fetchData || entityType ? entityActionsServiceDataLocal?.data || [] : entityActions;

    const handleEntityActionRef = useRef();

    const filteredActions = actualEntityActions?.filter(shouldShowEntityAction); // TODO Handle edit

    if (hideIfEmpty && (!filteredActions || filteredActions?.length === 0)) {
        return null;
    }

    const isPriorityActions = filteredActions?.filter((action) => action?.isPriority);

    return (
        <>
            <div style={{ display: "flex", gap: "10px" }}>
                {isPriorityActions?.map((entityAction) => {
                    return <EntityActionButton key={entityAction?.type} size={"small"} appProps={appProps} entityAction={entityAction} onSuccess={onSuccess} fullWidth={true} />;
                })}
                <DotsMenu
                    loading={loading}
                    items={(extraItems || []).concat(
                        filteredActions?.map((entityAction) => {
                            const href = getEntityActionUrl(entityAction);
                            const disabledReason = getEntityActionDisabledReason(entityAction);
                            if (isEntityActionDelete(entityAction)) {
                                return {
                                    style: {
                                        color: COLORS.ERROR,
                                        fontWeight: "bold",
                                    },
                                    label: getEntityActionLabel(entityAction),
                                    description: disabledReason || getEntityActionDescription(entityAction),
                                    disabled: !!disabledReason,
                                    href: !disabledReason && href ? href : undefined,
                                    onClick: !disabledReason && !href && (() => handleEntityActionRef?.current?.onActionClick(entityAction)),
                                };
                            }
                            return {
                                label: getEntityActionLabel(entityAction),
                                description: disabledReason || getEntityActionDescription(entityAction),
                                disabled: !!disabledReason,
                                href: !disabledReason && href ? href : undefined,
                                onClick: !disabledReason && !href && (() => handleEntityActionRef?.current?.onActionClick(entityAction)),
                            };
                        }),
                    )}
                />
                <EntityActionModal
                    appProps={appProps}
                    ref={handleEntityActionRef}
                    entity={entity}
                    entityType={entityType}
                    entityActionManualData={entityActionManualData}
                    onSuccess={onSuccess}
                    onOpenModal={onOpenModal}
                    onError={onError}
                    initialLanguageCode={initialLanguageCode}
                />
            </div>
        </>
    );
}
